// package imports
import React, { Component } from 'react'
import { Modal, Button } from 'react-bootstrap'
import moment from 'moment'

// project imports
import { DatePicker } from '../../index'
import './datepicker-modal.css'
import { Button as UiButton } from "components"
import {
  CalendarIcon,
  CalenderIcon,
  CheckSecondaryImg,
  CloseIconBlack
} from 'constants/Images'
import DatepickerTextfield from '../datepicker-textfield/DatepickerTextfield'
import FamilyMemberTypeEnum from 'modules/family-details-form/FamilymemberTypeEnum'
import AuthStore from 'modules/login/store/AuthStore'
import { HUF } from 'constants/ CustomerType'

class DatepickerModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      show: false,
      selectedDate: '',
      updatedDate: '',
      error: ''
    }
  }
  handleDatePickerOpenModal() {
    this.setState({ show: true })
    // this.setState({prevSelectedDate:this.state.selectedDate})

  }

  handleDatePickerCloseModal() {
    this.setState({ updatedDate: this.state.selectedDate })
    this.setState({ show: false })
  }

  handleDatePickerDropDown = (data) => {
    // console.log('handleDatePickerDropDown ', data)
    // let validate = moment(data, 'DD-MM-YYYY', true).isValid()
    // if (validate) {
      // console.log('selectedDatedms ', this.state.selectedDate)
      // let modifedDate = ''
      // modifedDate = moment(data, 'DD-MM-YYYY').format('YYYY-MM-DD')
      // console.log('selectedDatedms modifedDate ', modifedDate)
      this.setState({ updatedDate: data, selectedDate: data })
      // console.log('selectedDatedms ', this.state.selectedDate)
    // }
    // console.log('selectedDate ', this.state.selectedDate)
  }

  handleDatePickerError = (errors) => {
    // if (errors) {
    //   this.setState({ error: true })
    // } else {
    //   this.setState({ error: false })
    // }
  }

  onDatePickerChange = (date) => {
    // console.log('onDatePickerChange ', date)
    this.setState({ updatedDate: date })

  }

  onUpdateDatePicker = () => {
    let error = this.validateDOB()
    this.setState({ error: error })
    if(!error) {
      let { updatedDate, selectedDate } = this.state
      this.setState({ selectedDate: updatedDate == '' ? selectedDate : updatedDate, show: false })
      this.props.onChange(this.state.updatedDate)
    }
  }
  preSelectedDate = () => {

    try {
      let validate = moment(this.props.date, 'DD-MM-YYYY', true).isValid()
      let modifedDate = this.props.date
      if (!validate) {
         modifedDate = moment(this.props.date).format('DD-MM-YYYY')
      }
      let selectedDate = this.props.date || ""
      this.setState({ selectedDate })
    } catch (error) { }
  }
  componentDidUpdate(prevProps, prevState) {  
  // Typical usage (don't forget to compare props):
    if (this.props.date !== prevProps.date) {
      this.preSelectedDate()
    }

    if (this.state.selectedDate !== prevState.selectedDate) {
      this.setState({ error: '' })
    }
  }
  componentDidMount() {

    this.preSelectedDate()
  }

  validateDOB() {
    let value = this.state.selectedDate
    let modifedDate = moment(value, 'DD-MM-YYYY').format("YYYY-MM-DD")
    let years = moment().diff(moment(modifedDate), 'years')
    // var years = age.years();
    let validate = moment(value, 'DD-MM-YYYY', true).isValid();
    let errorMessage = ''
    if (validate) {
      if (this.props.minDate) {
        let yearDiff = moment().year()
        let yearDiff1 = moment(modifedDate).year()
        const minAge = moment().diff(this.props.minDate, 'years');
        let lastYear = moment().subtract(yearDiff - 1900, 'years').year();
        if (years < minAge && this.props?.memberType !== FamilyMemberTypeEnum.EMPLOYER && (this.props?.memberType !== FamilyMemberTypeEnum.FAMILYMEMBER && AuthStore.journeyTypeName != HUF)) {
          errorMessage = `Please enter the age more than ${minAge} years`

        } else if (lastYear > yearDiff1) {
          errorMessage = 'Please enter eligible date'
        }
        // else {
        //   return ''
        // }
      }
      if (this.props.maxDate) {
        const maxAge = moment().diff(this.props.maxDate, 'years');

        if ((years >= maxAge || !moment().isAfter(moment(modifedDate))) && this.props?.memberType !== "CHILD") {
          errorMessage = `Please enter the age less than ${maxAge} years`

        }
        //  else {
        //   return ''
        // }
      }
      // setDateTextfield(value);

    } else {
      errorMessage = 'Please enter a valid Date of Birth';
    }
    return errorMessage;
  }
  

  render() {
    // console.log('DATE PICKER MODAL RENDER >> ', typeof this.state.selectedDate)
    const { selectedDate } = this.state

    const { textStyle, plain, showErrorMsg, errorMsg, disabled, tabindex } = this.props;
    const dateFormat = 'DD-MM-YYYY'
    const validateDate = moment(this.props.value, 'DD-MM-YYYY', true).isValid()
    let formatedValue = dateFormat
    if(!validateDate && this.props.value) {
      formatedValue = moment(this.props.value).format(dateFormat) 
    } else if(this.props.value) {
      formatedValue = this.props.value
    }
    const date =  formatedValue 
    // const date = validateDate ? selectedDate : validateFormatedvValue ? formatedValue : dateFormat

    return (

      <>

        <Button tabindex={tabindex} variant='' disabled={disabled} className={`font-size-12 font-weight-medium p-1 btn date-picker-btn d-flex align-items-center justify-content-between w-100 text-primary-title-label-color bg-white rounded ${plain ? 'border-sm' : ''} ${plain && showErrorMsg ? 'validate' : ''} ${showErrorMsg ? 'validate' : ''}`} onClick={() => { this.handleDatePickerOpenModal() }}>
          <span className={textStyle || ''}>{date}</span>
          {plain ? '' : <img className='d-md-block' width='15' height='15' src={CalendarIcon} alt='calendar-icon' />}
        </Button>
        {showErrorMsg && <p className='text-danger mb-0 font-weight-light font-size-12 align-items-start d-flex'>{errorMsg ? errorMsg : 'Select a value'}</p>}
        <Modal
          className='date-picker-modal left-bottom-swipe-modal'
          show={this.state.show}
          onHide={() => { this.handleDatePickerCloseModal() }}
          // backdrop='static'
          keyboard={false}
        // animation={false}
        >

          <Modal.Header closeButton={false} className='pb-0 border-bottom-0'>
            <Modal.Title className='font-size-20 text-primary-title-label-color'>
              <img
                src={CalenderIcon}
                alt="family-icon"
                className="add-family-member-card-modal-top-img mb-1"
              />
              <span style={{ color: "#DF6336", fontSize: "18px" }}>Date Picker</span>
            </Modal.Title>
            <div className="d-flex mt-1">
              <UiButton variant='' className='d-inline-flex align-items-center p-0' onClick={() => { this.onUpdateDatePicker() }}>
                <img src={CheckSecondaryImg} alt='checked-icon' className='fm-modal-btn-icon font-weight-bold' />
                <p className='mb-0 font-size-16 font-size-md-12 font-weight-bold text-secondary pl-1'>Done</p>
              </UiButton>
              <UiButton variant='' className='d-inline-flex align-items-center p-0 ml-2' onClick={() => { this.setState({ show: false }) }} >
                <img src={CloseIconBlack} alt='close-icon' className='fm-modal-btn-icon font-weight-bold' />
                <p className='mb-0 font-size-16 font-size-md-12 font-weight-bold pl-1'>Cancel</p>
              </UiButton>

            </div>
          </Modal.Header>
          <Modal.Body className='pt-0'>
            <p className='modal-date-picker-subtext font-size-16 mt-2'>Adjust the date of your birth</p>


            <DatepickerTextfield updatedDate={this.state.updatedDate} dateField={this.state.selectedDate} minDateField={this.props.minDate} maxDateField={this.props.maxDate} handleDatePickerDropDown={this.handleDatePickerDropDown} handleDatePickerError={this.handleDatePickerError} error1={this.state.error} memberType={this.props?.memberType} onUpdateDatePicker={this.onUpdateDatePicker}/>

            <DatePicker minDate={this.props.minDate} maxDate={this.props.maxDate} date={this.state.selectedDate} onChange={this.onDatePickerChange} memberType={this.props?.memberType}/>
          </Modal.Body>
          {/* <Modal.Footer>
            <Button variant='secondary' className='w-100 font-size-18 m-0' onClick={() => { this.onUpdateDatePicker() }}>
              Done
            </Button>
          </Modal.Footer> */}
        </Modal>
      </>
    )
  }
}

DatepickerModal.defaultProps = {
  showErrorMsg: false,
  disabled: false
}

export default DatepickerModal
